
import {windVane} from '../../../utils/tmallGenius';
import {updateDevInfo,} from "../../../api/index";
import {aligenie} from "../../../utils/tmallGenius";
import Checklist from 'vux/src/components/checklist/index.vue'


export default {
components: {Checklist,},
data() {
return {
checkedVal: [],
list: aligenie.roomList,
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("设备所在房间");
next();
},
/*------------------------------------------- 启动运行 -------------------------------------------*/
created() {
},
methods: {
/*------------------------------------------- 自定义函数 -------------------------------------------*/
/*------------------------------------------- 绑定函数 -------------------------------------------*/
selectChange() {
let selectedVal = this.checkedVal[0];        //checkedVal[0]就是所选值
if (selectedVal) {
updateDevInfo({
m: "updateZone",
token: sessionStorage.getItem("token"),
deviceId: this.$route.query.deviceId,
zone: selectedVal,
});
this.toast_success();
setTimeout(() => {
this.$router.replace({ //去设置页面
path: '/device/xiaofang',
query: {
...this.$route.query,
aligenieZone: selectedVal,
}
});
}, 2000);
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/SelectRoom.vue